import PropTypes from 'prop-types'

export const clanInfoPropTypes = PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tag: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    emblemUrl: PropTypes.string.isRequired,
})

export const battleInfoPropTypes = PropTypes.shape({
    provinceId: PropTypes.number,
    provinceName: PropTypes.string.isRequired,
    arenaName: PropTypes.string.isRequired,
    peripheryName: PropTypes.string.isRequired,
    respawnName: PropTypes.string,
    isPlanned: PropTypes.bool.isRequired,
    enemyClan: clanInfoPropTypes,
    startsAt: PropTypes.string.isRequired,
})



// WEBPACK FOOTER //
// ./containers/WGCWXBattleSchedule/propTypes.js